'use client';

import { FC, HTMLAttributes, MouseEvent, useCallback } from 'react';
import PrismAPI from '@modules/prism-client/types/prism-types';
import { createMxp365OpenEvent } from './events';
import { logger } from '@tuic/logger';
type Props = HTMLAttributes<HTMLAnchorElement> & {
  data: PrismAPI.Mxp365Link;
};
export const Mxp365Link: FC<Props> = ({
  data,
  children,
  ...anchorProps
}) => {
  const handleClick = useCallback((e: MouseEvent<HTMLAnchorElement>) => {
    // Parse the URL to extract components
    const url = new URL(data.url);

    // Extract token (required)
    const token = url.searchParams.get('token');
    if (!token) {
      logger.error('MXP365 URL missing token:', data.url);
      return;
    }

    // Extract path and remove /mxp365tiles prefix
    let path = url.pathname;
    if (path.startsWith('/mxp365tiles')) {
      path = path.substring('/mxp365tiles'.length) || '/';
    }

    // Collect other query parameters
    const queryParams: Record<string, string> = {};
    url.searchParams.forEach((value, key) => {
      if (key !== 'token') {
        queryParams[key] = value;
      }
    });

    // Dispatch custom event with structured data
    const event = createMxp365OpenEvent({
      title: data.title,
      path,
      token,
      queryParams: Object.keys(queryParams).length > 0 ? queryParams : undefined,
      telemetry: data.telemetry
    });
    window.dispatchEvent(event);
    anchorProps.onClick?.(e);
  }, [data.url, data.title, data.telemetry]);
  return <a {...anchorProps} href="#" onClick={handleClick} data-no-page-transition="true" data-sentry-component="Mxp365Link" data-sentry-source-file="Mxp365Link.tsx">
      {children}
    </a>;
};